module.exports = __webpack_public_path__ + "h5/img/evaluate-icon.84c417d1.png";